import {
    BarChart, Bar, Cell, XAxis, YAxis, Tooltip, ResponsiveContainer,
} from 'recharts';
import {
    ADMISSION_STATUS_COLORS,
    ADMISSION_STATUS_SHORT_LABELS,
} from '../../constants/admissionStatus';
import '../../styles/CaseListMetrics.css';

function StatusHistogram({ histogram, activeCount }) {
    const data = histogram.map((b) => ({
        status: b.status,
        shortLabel: ADMISSION_STATUS_SHORT_LABELS[b.status] || b.status,
        count: b.count,
    }));

    return (
        <div className="case-list-metrics__card case-list-metrics__chart">
            <div className="case-list-metrics__card-header">
                <span className="case-list-metrics__card-label">
                    Active cases by status
                </span>
                <span className="case-list-metrics__chart-total">
                    {activeCount} active
                </span>
            </div>
            <div className="case-list-metrics__chart-body">
                <ResponsiveContainer width="100%" height={96}>
                    <BarChart data={data} margin={{ top: 4, right: 4, bottom: 0, left: 0 }}>
                        <XAxis
                            dataKey="shortLabel"
                            tickLine={false}
                            axisLine={false}
                            tick={{ fontSize: 10, fill: '#777' }}
                        />
                        <YAxis hide />
                        <Tooltip
                            cursor={{ fill: 'rgba(0,0,0,0.04)' }}
                            formatter={(value, _name, item) => [value, item.payload.status]}
                        />
                        <Bar dataKey="count" radius={[3, 3, 0, 0]}>
                            {data.map((entry) => (
                                <Cell
                                    key={entry.status}
                                    fill={ADMISSION_STATUS_COLORS[entry.status]}
                                />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}

export default StatusHistogram;
